export interface Country {
    id?: number;
    name?: string;
    phone_prefix?: string;
    is_active?: boolean;
}

export interface CountryDataForm {
    name?: string;
    phone_prefix?: string;
}

export interface CountryFilters {
    name?: string;
    phone_prefix?: string;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultCountryDataForm: CountryDataForm = {
    name: '',
    phone_prefix: ''
};
